const stack: HTMLElement[] = [];
const focusable = 'button:not(:disabled),a[href],input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';

/** Keep the existing sheet markup and appearance; manage its focus and background. */
export function activateModal(sheet: HTMLElement, close: () => void, opener: HTMLElement | null): () => void {
  const openerId = opener?.id;
  const openerTestId = opener?.getAttribute("data-testid");
  stack.push(sheet);
  const top = () => stack.at(-1) === sheet;
  if (!sheet.contains(document.activeElement)) sheet.focus({ preventScroll: true });
  const background: { el: HTMLElement; inert: boolean }[] = [];
  for (let branch: HTMLElement = sheet; branch.parentElement; branch = branch.parentElement) {
    for (const sibling of branch.parentElement.children) {
      if (!(sibling instanceof HTMLElement) || sibling === branch || sibling === sheet.previousElementSibling && sibling.classList.contains("scrim") || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) continue;
      background.push({ el: sibling, inert: sibling.inert });
      sibling.inert = true;
    }
  }
  const nodes = () => [...sheet.querySelectorAll<HTMLElement>(focusable)].filter(el => el.tabIndex >= 0 && !el.closest('[hidden],[inert],[aria-hidden="true"]') && el.getClientRects().length > 0);
  const key = (e: KeyboardEvent) => {
    if (!top()) return;
    if (e.key === "Escape") { e.preventDefault(); e.stopPropagation(); close(); }
    if (e.key !== "Tab") return;
    const list = nodes(), first = list[0], last = list.at(-1);
    if (!first) { e.preventDefault(); sheet.focus({ preventScroll: true }); return; }
    if (e.shiftKey && (document.activeElement === first || document.activeElement === sheet)) { e.preventDefault(); last?.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || document.activeElement === sheet)) { e.preventDefault(); first.focus(); }
  };
  const focus = (e: FocusEvent) => { if (top() && !sheet.contains(e.target as Node)) sheet.focus({ preventScroll: true }); };
  document.addEventListener("keydown", key, true);
  document.addEventListener("focusin", focus);
  return () => {
    document.removeEventListener("keydown", key, true);
    document.removeEventListener("focusin", focus);
    const index = stack.indexOf(sheet); if (index >= 0) stack.splice(index, 1);
    for (const { el, inert } of background) el.inert = inert;
    queueMicrotask(() => {
      const target = opener?.isConnected ? opener : openerId ? document.getElementById(openerId) : openerTestId ? document.querySelector<HTMLElement>(`[data-testid="${CSS.escape(openerTestId)}"]`) : null;
      if (target && (!stack.length || stack.at(-1)?.contains(target))) target.focus({ preventScroll: true });
    });
  };
}
